import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { temporaryEndpoints } from 'http/endpoints';
import { isStoreInitialized, performSetAction } from 'models/utils/utils';
import {
  SingleTeammate,
  SingleTeammateProps,
} from './single-teammate/single-teammate';

export interface TeammatesListProps {
  data: SingleTeammateProps[];
  status: LoadingState;
}

export const TeammatesList = types
  .model({
    data: types.optional(types.array(SingleTeammate), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: TeammatesListProps): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        ...props,
      });
    },
    updateStatus(status: LoadingState): void {
      applySnapshot(self, {
        ...getSnapshot(self),
        status,
      });
    },
  }))
  .actions((self) => ({
    async setTeammates(): Promise<void> {
      await performSetAction({
        store: self,
        endpoint: temporaryEndpoints.teammatesList,
      });
    },
  }))
  .actions((self) => ({
    async init(): Promise<void> {
      const { status } = getSnapshot(self);
      if (isStoreInitialized(status)) return;
      await self.setTeammates();
    },
    async update(): Promise<void> {
      await self.setTeammates();
    },
  }));

export const teammatesList = TeammatesList.create();
export type TeammatesListSnapshot = SnapshotIn<typeof TeammatesList>;
export type TeammatesListInstance = Instance<typeof TeammatesList>;
export default teammatesList;
